export const purposeOfCallDistributionCardData = [
  {title: "Medical Records Request", total_calls: 5000, type: "frequent"},
  {title: "Insurance Coverage", total_calls: 5000, type: "often"},
  {title: "Insurance Payments", total_calls: 4999, type: "sometimes"},
  {title: "Billing Inquires", total_calls: 1997, type: "rarely"},
  {title: "Technical Issues", total_calls: 2500, type: "frequent"},
  {title: "Prescription Refill Assistance", total_calls: 6000, type: "often"},
  {title: "Payment Plan Setup", total_calls: 3000, type: "frequent"}, 
  {title: "Insurance Verification", total_calls: 4999, type: "sometimes"},
  {title: "Billing Inquires", total_calls: 1500, type: "rarely"},
  {title: "Health Advice", total_calls: 2000, type: "sometimes"},
  {title: "Appointments", total_calls: 4000, type: "frequent"},
  {title: "Prescription Issue", total_calls: 3999, type: "rarely"},
  {title: "General Inquiries", total_calls: 5000, type: "frequent"},
  
  
];